import {useMemo, useState} from 'react';
import {BasicTableComponent} from 'components/table/table-basic.component';
import {TableButtonSortComponent} from 'components/table/table-button-sort.component';
import {TableSearchInputComponent} from 'components/table/table-search.component';
import {ModalTableSortComponent} from 'components/modal/modal-table-sort.component';
import {catchErrorMessage} from 'ui-utils/string.utils';
import {EmptyStateComponent} from 'components/empty-data';
import {StandartImageComponent} from 'components/image/standart-image.component';
import {Pagination} from 'components/table/table-pagination.component';
import {useNavigate} from 'react-router-dom';
import {useAnalyticBAVisitorList} from 'api/report-ba/visitor/visitor.query.api';
import {HighlightedText} from 'components/highlighted-text';

const SORT_OPTIONS = [
  { label: 'Urutkan Nama BA A-Z', sortType: 'asc', sortBy: 'user_name' },
  { label: 'Urutkan Nama BA Z-A', sortType: 'desc', sortBy: 'user_name' },
  { label: 'Urutan Toko A-Z', sortType: 'asc', sortBy: 'store_name' },
  { label: 'Urutan Toko Z-A', sortType: 'desc', sortBy: 'store_name' },
];

export function AnalyticVisitorTable({ bodyFilter, dateFilter, queryFilter, setQueryFilter }) {
  const navigate = useNavigate();
  const [modals, setModals] = useState({
    sort: false,
  });

  const { data, isLoading, isError, error } = useAnalyticBAVisitorList({
    body: bodyFilter,
    filter: {
      ...queryFilter,
      ...dateFilter,
    },
  });

  const columns = useMemo(
    () => [
      {
        name: 'BA Name',
        className: 'w-[250px] text-sm font-semibold text-green px-4',
        dataIndex: 'user',
        render: (record) => (
          <div class='w-[250px] text-sm font-semibold text-green px-4'>
            <div class='flex items-center'>
              <div class='w-12'>
                <StandartImageComponent
                  src={record?.user_image || '/img/default-user.jpg'}
                  class='w-12 h-12 object-cover'
                />
              </div>
              <div class='w-auto pl-5 xl:pl-5'>
                <div
                  onClick={() => {
                    navigate(`/users/list/details/${record?.user_id}`);
                  }}
                  class='overflow-hidden block text-ellipsis whitespace-nowrap text-sm font-semibold text-dark hover:text-green mb-1'
                >
                  <HighlightedText text={record?.user_name} highlight={queryFilter?.search} />
                </div>
              </div>
            </div>
          </div>
        ),
      },
      {
        name: 'Store Name',
        className: 'w-[250px] text-sm font-semibold text-green px-4',
        dataIndex: 'user',
        render: (record) => (
          <div class='w-[250px] px-4'>
            <div class='text-sm font-semibold text-dark mb-1'>
              <HighlightedText text={record?.store_name} highlight={queryFilter?.search} />
            </div>
          </div>
        ),
      },
      {
        name: 'Jml\nPengunjung',
        className: 'w-[120px] text-sm font-semibold text-green text-center whitespace-pre-line px-4',
        dataIndex: 'total_visitor',
        render: (record, total_visitor) => (
          <div class='w-[120px] px-4'>
            <div class='text-sm font-medium text-center text-gray'>{total_visitor?.toLocaleString()}</div>
          </div>
        ),
      },
      {
        name: 'Jml\nPembeli',
        className: 'w-[120px] text-sm font-semibold text-green text-center whitespace-pre-line px-4',
        dataIndex: 'total_buyer',
        render: (record, total_buyer) => (
          <div class='w-[120px] px-4'>
            <div class='text-sm font-medium text-center text-gray'>{total_buyer?.toLocaleString()}</div>
          </div>
        ),
      },
      {
        name: 'Jml\nTrialist',
        className: 'w-[120px] text-sm font-semibold text-green text-center whitespace-pre-line px-4',
        dataIndex: 'total_trial',
        render: (record, total_trial) => (
          <div class='w-[120px] px-4'>
            <div class='text-sm font-medium text-center text-gray'>{total_trial?.toLocaleString()}</div>
          </div>
        ),
      },
      {
        name: 'BA\nConversion',
        className: 'w-[120px] text-sm font-semibold text-green text-center whitespace-pre-line px-4',
        dataIndex: 'ba_conversion',
        render: (record, ba_conversion) => (
          <div class='w-[120px] px-4'>
            <div class='text-sm font-medium text-center text-gray'>{`${ba_conversion?.toLocaleString()}%`}</div>
          </div>
        ),
      },
      {
        name: 'Avoskin',
        className: 'w-[120px] text-sm font-semibold text-green text-center whitespace-pre-line px-4',
        dataIndex: 'avoskin',
        render: (record, avoskin) => (
          <div class='w-[120px] px-4'>
            <div class='text-sm font-medium text-center text-gray'>{`${avoskin?.toLocaleString()}%`}</div>
          </div>
        ),
      },
      {
        name: 'Lacoco',
        className: 'w-[120px] text-sm font-semibold text-green text-center whitespace-pre-line px-4',
        dataIndex: 'lacoco',
        render: (record, lacoco) => (
          <div class='w-[120px] px-4'>
            <div class='text-sm font-medium text-center text-gray'>{`${lacoco?.toLocaleString()}%`}</div>
          </div>
        ),
      },
      {
        name: 'Looke',
        className: 'w-[120px] text-sm font-semibold text-green text-center whitespace-pre-line px-4',
        dataIndex: 'looke',
        render: (record, looke) => (
          <div class='w-[120px] px-4'>
            <div class='text-sm font-medium text-center text-gray'>{`${looke?.toLocaleString()}%`}</div>
          </div>
        ),
      },
      {
        name: 'Oasea',
        className: 'w-[120px] text-sm font-semibold text-green text-center whitespace-pre-line px-4',
        dataIndex: 'oasea',
        render: (record, oasea) => (
          <div class='w-[120px] px-4'>
            <div class='text-sm font-medium text-center text-gray'>{`${oasea?.toLocaleString()}%`}</div>
          </div>
        ),
      },
      {
        name: 'Glow Better',
        className: 'w-[120px] text-sm font-semibold text-green text-center whitespace-pre-line px-4',
        dataIndex: 'glow_better',
        render: (record, glow_better) => (
          <div class='w-[120px] px-4'>
            <div class='text-sm font-medium text-center text-gray'>{`${ glow_better?.toLocaleString()}%`}</div>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queryFilter?.search]
  );

  return (
    <>
      <div class='flex items-center mb-5'>
        <TableSearchInputComponent
          placeholder='Cari nama BA atau nama toko'
          inputProps={{
            disabled: isLoading,
          }}
          onSearch={(value) => {
            setQueryFilter({ ...queryFilter, search: value.keyword, page: 1 });
          }}
        />
        <TableButtonSortComponent disabled={isLoading} onClick={() => setModals({ ...modals, sort: true })} />
      </div>

      <BasicTableComponent
        error={isError}
        loading={isLoading}
        errorTitle={`${error?.response?.data?.status} - ${error?.response?.data?.code}`}
        errorMessage={catchErrorMessage(error?.response?.data?.message)}
        rowClassName='flex items-center rounded-sm py-4 px-2 border border-solid border-transparent hover:border-green bg-white hover:bg-light-green transition duration-75 ease-in-out cursor-pointer'
        columns={columns}
        dataSource={data?.data?.rows || []}
        scrollable
        minWidth='1580px'
      />

      {data?.data?.total_result === 0 && (
        <EmptyStateComponent
          className='flex flex-col items-center justify-center h-44'
          message={queryFilter.search ? `No result for query "${queryFilter.search}"` : 'No data available'}
        />
      )}

      <Pagination
        currentPage={queryFilter.page}
        pageSize={queryFilter.limit}
        siblingCount={1}
        totalCount={data?.data?.total_result || 0}
        onPageChange={(page) => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
          setQueryFilter({ ...queryFilter, page });
        }}
      />
      <ModalTableSortComponent
        options={SORT_OPTIONS}
        initialValue={SORT_OPTIONS.find(
          (sortItem) => sortItem.sortBy === queryFilter.orderBy && sortItem.sortType === queryFilter.orderType
        )}
        onChange={({ selected }) => {
          setQueryFilter((prevState) => ({
            ...prevState,
            orderBy: selected.sortBy,
            orderType: selected.sortType,
          }));
          setModals({ ...modals, sort: false });
        }}
        visible={modals.sort}
        onClose={() => setModals({ ...modals, sort: false })}
      />
    </>
  );
}
